import newExploreApi from "@api/new-explore";
import { STATUS } from "@types";
import {
  EXPLORE_SORT,
  EXPLORE_SORT_QUERY,
} from "enums/new-explore/explore-sort";
import { CourseExploreApi, exploreMethodBySlug } from "types/api/new-explore";

export const DEFAULT_EXPLORE_SORT = EXPLORE_SORT.MOST_SOLD;

export const INSTRUCTOR_BG_SRC =
  "https://faradars.org/wp-content/uploads/2025/03/08/bg-instructor.svg";
export const INSTRUCTOR_AVATAR_FALLBACK =
  "https://cdn.faradars.org/wp-content/uploads/2023/01/25/instractur.svg";

export const publishSorting = [
  STATUS.PLANNING,
  STATUS.START_RECORDING,
  STATUS.RECORDING,
  STATUS.EDITING,
  STATUS.QUALITY_INSPECTION,
  STATUS.PUBLISHING,
];

export const productSearchExplore = newExploreApi[
  exploreMethodBySlug.course
] as CourseExploreApi;

export const InstructorPaginationLimit = 8;

export const sortItem = [
  {
    name: EXPLORE_SORT.MOST_SOLD,
    query: EXPLORE_SORT_QUERY.POPULAR,
    count: 0,
    selected: false,
    persian_name: "پرمخاطب‌ترین",
  },

  {
    name: EXPLORE_SORT.NEWEST,
    query: EXPLORE_SORT_QUERY.NEWEST,
    count: 0,
    selected: false,
    persian_name: "جدیدترین",
  },
];

export const SCROLL_OFFSET_ADMIN = 146;
export const SCROLL_OFFSET_USER = 96;
